import { com } from '@eidu/web'
import GlobalAction = com.eidu.sharedlib.entity.permission.GlobalAction
import Action = com.eidu.sharedlib.entity.permission.Action
import EntityAction = com.eidu.sharedlib.entity.permission.EntityAction

const actionLabel = (action: Action): string => {
  switch (action) {
    case GlobalAction.ManageEntityTypes:
      return 'Manage entity types'
    case GlobalAction.ManageAuthentication:
      return 'Manage authentication'
    case GlobalAction.ManagePermissionGrants:
      return 'Manage permission grants'
    case GlobalAction.ManageForms:
      return 'Manage forms'
    case GlobalAction.ManageDatasets:
      return 'Manage datasets'
    case EntityAction.SubmitForm:
      return 'Submit forms'
    case EntityAction.ViewFormSubmissions:
      return 'View form submissions'
    case EntityAction.ShareSchoolLogin:
      return 'Share school logins'
    case GlobalAction.ViewAuditLog:
      return 'View audit log'
    case EntityAction.CreateEntity:
      return 'Create'
    case EntityAction.ReadEntity:
      return 'Read'
    case EntityAction.UpdateEntity:
      return 'Update'
    case EntityAction.DeleteEntity:
      return 'Delete'
    case EntityAction.PublishAsset:
      return 'Publish'
    default:
      return action.toString()
  }
}

export default actionLabel
